var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSearchTagPost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1862_170508)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.6666 14.0007V5.33398C2.6666 4.80355 2.87731 4.29484 3.25238 3.91977C3.62745 3.5447 4.13616 3.33398 4.6666 3.33398H11.3333C11.8637 3.33398 12.3724 3.5447 12.7475 3.91977C13.1225 4.29484 13.3333 4.80355 13.3333 5.33398V9.33398C13.3333 9.86442 13.1225 10.3731 12.7475 10.7482C12.3724 11.1233 11.8637 11.334 11.3333 11.334H5.33326L2.6666 14.0007Z",
    stroke: "#EB0000",
    strokeWidth: 1.12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 7.33398V7.34065",
    stroke: "#EB0000",
    strokeWidth: 1.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.3334 7.33398V7.34065",
    stroke: "#EB0000",
    strokeWidth: 1.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6666 7.33398V7.34065",
    stroke: "#EB0000",
    strokeWidth: 1.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1862_170508"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearchTagPost);
export default __webpack_public_path__ + "static/media/icon_search_tag_post.21ee661253cb2fee532118bff5056fe0.svg";
export { ForwardRef as ReactComponent };